var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GrootHeroBanner',{attrs:{"title":_vm.$t('common.greeting') + ' ' + _vm.getFirstName,"breadcrumbs":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }